import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  overflow: hidden;
  height: 100%;
`;

export const Head = styled.div``;

export const Title = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: #1b203a;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1; /* number of lines to show */
  line-clamp: 1;
  -webkit-box-orient: vertical;

  &.fieldLabel {
    font-weight: 500;
    font-size: 14px;
    height: 22px;
    align-items: center;
  }
`;

export const TitleSection = styled.div`
  font-weight: 500;
  color: #1b203a;
  font-size: 14px;
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 7px;

  &.fieldLabel {
    gap: 8px;
    height: 22px;
    margin-bottom: 16px;
  }

  &.header {
    width: 100%;
    height: 32px;
    justify-content: space-between;
  }
`;

export const LighterText = styled.div`
  font-size: 12px;
  font-weight: 400;
  color: #474d66;

  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1; /* number of lines to show */
  line-clamp: 1;
  -webkit-box-orient: vertical;

  &.header {
    margin-left: 39px;
  }
`;

interface IDivider {
  width?: string;
  height?: string;
}

export const Divider = styled.div<IDivider>`
  width: ${({ width }) => width};
  height: ${({ height }) => height};
`;

export const IconWrapper = styled.div`
  height: 16px;
  width: 16px;
  margin-top: -3px;
`;

export const Item = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 14px 12px 14px 12px;
`;

export const LineDivider = styled.div`
  width: 100%;
  border-bottom: 1px solid #e6e8f0;
`;

export const ItemData = styled.div``;

export const ItemText = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: #1371fe;
`;

export const IconButton = styled.div`
  height: 16px;
  cursor: pointer;

  &.backIcon {
    display: flex;
    align-items: center;
    justify-content: center;
    padding-top: 5px;
    height: 32px;
    width: 32px;
    border-radius: 8px;

    transition: 0.2s;

    :hover {
      background-color: #f6f8ff;
    }
  }
`;

export const Items = styled.div`
  flex: 1;
  margin-top: 24px;
  overflow-y: auto;
  overflow-x: hidden;

  ::-webkit-scrollbar {
    width: 24px;
    height: 18px;
  }
  ::-webkit-scrollbar-thumb {
    height: 6px;
    border: 8px solid rgba(0, 0, 0, 0);
    background-clip: padding-box;
    border-radius: 12px;
    background-color: rgba(0, 0, 0, 0.15);
  }
  ::-webkit-scrollbar-button {
    width: 0;
    height: 0;
    display: none;
  }
  ::-webkit-scrollbar-corner {
    background-color: transparent;
  }
`;

export const Wrapper = styled.div`
  flex: 1;
`;
